import { createContext } from 'react'
import { AccountResponseWithConsentDetails, UserTypes } from '../../types/Account'
import { JsonWebToken } from '../../utils/jwt/types'

export type UserInfo = {
  // username represents the first party platform account nickname.
  // e.g. xbox uses the modern_gamertag, psn uses online_id, etc.
  username: string
  // suffix is a identifier suffix that can be used along with username.
  // e.g. xbox live uses a modern_gamertag_suffix like #123
  suffix: string
}

export interface AuthState {
  userType: UserTypes
  jwt: JsonWebToken | null
  jwtRaw: string
  isLoading: boolean
  accountInfo?: AccountResponseWithConsentDetails['account']
  userInfo: UserInfo
}

export interface AuthContextType {
  authState: AuthState
  setAuthToken: (token: string, userInfo: UserInfo) => void
  refreshAuthState: () => void
  logout: () => void
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

export default AuthContext
